import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { getData as apiGetData } from 'api/Api'
import {
  FormControl
} from 'react-bootstrap'
import Loader from 'components/Loader'
import {
  ListItem
} from 'components/List'
import KanBoIcon from 'components/KanBoIcon'
import Scrollbars from 'components/Scrollbars'
import { Waypoint } from 'react-waypoint'
import classes from './UserGroupPicker.module.scss'

const limit = 50

export class UserGroupPicker extends React.Component {
  static propTypes = {
    internal: PropTypes.bool.isRequired,
    ignoreUsers: PropTypes.array,
    onSelect: PropTypes.func,
    onDeselect: PropTypes.func
  }

  static defaultProps = {
    internal: false
  }

  constructor (props) {
    super(props)

    this.state = {
      userGroupIds: [],
      userGroupsById: {},
      loading: false,
      loaded: false,
      cursor: null,
      keyword: '',
      selectedUserGroups: []
    }

    this.getSelectedUserGroups = this.getSelectedUserGroups.bind(this)
    this.setUserPickerRef = this.setUserPickerRef.bind(this)
    this.fetchUserGroups = this.fetchUserGroups.bind(this)
    this.cancelFetchUserGroups = this.cancelFetchUserGroups.bind(this)
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this)
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.state.keyword !== prevState.keyword) {
      this.fetchUserGroups({
        refresh: true
      })
    }
  }

  componentWillUnmount () {
    this.cancelFetchUserGroups()
  }

  getSelectedUserGroups () {
    return this.state.selectedUserGroups.map(userGroupId => this.state.userGroupsById[userGroupId])
  }

  setUserPickerRef (ref) {
    this.userPickerRef = ref
  }

  fetchUserGroups ({ refresh }) {
    const { internal } = this.props
    const { userGroupIds, userGroupsById, keyword, cursor } = this.state

    this.cancelFetchUserGroups()

    if (refresh) {
      this.setState({
        userGroupIds: [],
        userGroupsById: {},
        loading: true,
        loaded: false,
        cursor: null
      })
    } else {
      this.setState({
        loading: true
      })
    }

    const args = {
      limit
    }
    if (typeof internal === 'boolean') args.internal = internal
    if (keyword) args.keyword = keyword
    if (!refresh && cursor) args.cursor = cursor

    this.fetchUserGroupsPromise = apiGetData('Groups', args)
    this.fetchUserGroupsPromise.then(({ Groups, Cursor }) => {
      const newUserGroupIds = []
      const newUserGroupsById = {}

      Groups.forEach(Group => {
        newUserGroupIds.push(Group.Id)
        newUserGroupsById[Group.Id] = {
          id: Group.Id,
          name: Group.Name,
          internal: Group.Internal,
          external: Group.External,
        }
      })

      if (refresh) {
        this.setState({
          userGroupIds: newUserGroupIds,
          userGroupsById: newUserGroupsById,
          loading: false,
          loaded: !Cursor,
          cursor: Cursor,
        })
      } else {
        this.setState({
          userGroupIds: [
            ...userGroupIds,
            ...newUserGroupIds
          ],
          userGroupsById: {
            ...userGroupsById,
            ...newUserGroupsById
          },
          loading: false,
          loaded: !Cursor,
          cursor: Cursor,
        })
      }

      this.cancelFetchUserGroups()
    })
  }

  cancelFetchUserGroups () {
    if (this.fetchUserGroupsPromise && this.fetchUserGroupsPromise.cancel) {
      this.fetchUserGroupsPromise.cancel()
      delete this.fetchUserGroupsPromise
    }
  }

  handleSearchInputChange (event) {
    this.setState({
      keyword: event.target.value
    })
  }

  render () {
    const {
      internal, // eslint-disable-line no-unused-vars
      ignoreUsers, // eslint-disable-line no-unused-vars
      onSelect,
      onDeselect
    } = this.props
    const {
      userGroupIds,
      userGroupsById,
      loaded,
      loading,
      cursor,
      keyword,
      selectedUserGroups
    } = this.state

    return (
      <div className={classes.kanboUserPicker}>
        <div className={classes.searchInputWrapper}>
          <FormattedMessage id='USERS_SEARCH_HINT'>
            {formattedMessage =>
              <FormControl
                autoFocus
                type='text'
                value={keyword}
                placeholder={formattedMessage}
                onChange={this.handleSearchInputChange}
              />
            }
          </FormattedMessage>
        </div>
        <Scrollbars
          className={classes.userPickerWrapper}
        >
          {userGroupIds.map(userGroupId => userGroupsById[userGroupId]).map(userGroup => {
            const isSelected = selectedUserGroups.indexOf(userGroup.id) >= 0

            const onUserGroupClick = () => {
              this.setState({
                selectedUserGroups:
                  !isSelected
                    ? [ ...selectedUserGroups, userGroup.id ]
                    : selectedUserGroups.filter(_id => _id !== userGroup.id)
              })

              if (isSelected) {
                if (onSelect) onSelect(userGroup.id)
              } else {
                if (onDeselect) onDeselect(userGroup.id)
              }
            }

            return (
              <ListItem
                key={userGroup.id}
                icon={
                  <KanBoIcon
                    name={(() => {
                      if (userGroup.internal) {
                        return 'kanbo-16-internal-user-group'
                      } else if (userGroup.external) {
                        return 'kanbo-16-external-user-group'
                      } else {
                        return 'kanbo-16-user-group'
                      }
                    })()}
                  />
                }
                onClick={onUserGroupClick}
                active={isSelected}
              >
                {userGroup.name}
              </ListItem>
            )
          })}
          {loading &&
            <Loader center />
          }
          {(!loading && !loaded) &&
            <Waypoint
              key={cursor}
              onEnter={this.fetchUserGroups}
              bottomOffset='-50%'
            />
          }
        </Scrollbars>
      </div>
    )
  }
}

export default UserGroupPicker
